import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch, hrLenseBaseUrl } from "../../../shared/Fetch";
import { Allocate } from "../Allocate";
import { EmptyRequirement } from "../EmptyRequirement";
import { Filter } from "../Filter";
import { Publish } from "../Publish";
import { IModel } from "./RequirementMast";
import { IAllRequirements } from "../../../models/AllRequirements";
import { format } from "date-fns";
import { SubmissionsTable } from "./SubmissionsTable";
import { Dialog } from "primereact/dialog";
import { IReqFilter, EmptyFilter } from "../Filter";
import { Tag } from "primereact/tag";
import { ReqQuery } from "../ReqQuery";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { Client_Type, Job_Type, Req_Term } from "../../../models/RequirementMast";
import { IncreaseSub } from "./IncreaseSub";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface Iprops {
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
  permissions: IPermissionProps;
  setSpinner: (is: boolean) => void;
  spinner: boolean;
  hideDialog: () => void;
  ShowCelebration: () => void;
  open?: boolean;
  Req_ID?: number;
}

export interface IModel2 {
  open: boolean;
  singleData: IAllRequirements;
}

export const TableMy = (props: Iprops) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>; loading: boolean });
  const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
  const [visible, setVisible] = useState({ singleData: {}, open: false } as { singleData: IAllRequirements; open: boolean });
  const toast = useRef(null);
  const dt = useRef<any>(null);
  const [historytableData, setHistorytableData] = useState({ historytableData: [], loading: false } as { historytableData: Array<any>; loading: boolean });
  const [reqTable, setReqTable] = useState({ contact_Person_Id: 0, open: false, loading: false, req_ID: 0 } as { contact_Person_Id: number; open: boolean; loading: boolean; req_ID: number });
  const [historyRepostData, setHistoryRepostData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>; loading: boolean });
  const [alreadyPostPoc, setAlreadyPostPoc] = useState(false);
  const [existingPocData, setExistingPocData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>; loading: boolean });
  const [alreadyPostPocLoading, setAlreadyPostPocLoading] = useState(false);

  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const [allocation, setAllocation] = useState({ singleData: {}, open: false } as IModel2);
  const hideAllocationDialog = () => {
    setAllocation({ singleData: {}, open: false });
  };
  const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
  const hidePublishDialog = () => {
    setPublish({ singleData: {}, open: false });
  };

  const [userModal, setUserModal] = useState({ open: false, data: null as any });
  const [userModalData, setUserModalData] = useState({ data: null as { employeeId?: number; empCode?: string; phoneNumber?: string; whatsAppNumber?: string; personalEmail?: string } | null });

  // const [filter, setFilter] = useState(false);
  // const hideFilterDialog = () => {
  //     setFilter(false);
  // };
  const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean; rrreason: string | undefined; req_ID: number | undefined });
  const hideRRRDialog = () => {
    setRRR({ open: false, rrreason: "", req_ID: 0 });
  };
  const [subTable, setSubTable] = useState({ req_id: 0, job_Title: "", open: false } as { req_id: number; job_Title?: string; open: boolean });
  const hideSubTable = () => {
    setSubTable({ req_id: 0, job_Title: "", open: false });
  };
  const [query, setQuery] = useState({ req_id: 0, open: false } as { req_id: number; open: boolean });
  const hideQueryDialog = () => {
    setQuery({ req_id: 0, open: false });
  };
  const [historyTable, setHistoryTable] = useState({ req_ID: 0, open: false } as { req_ID: number; open: boolean });
  const [openBlacklistSubmission, setOpenBlacklistSubmission] = useState(false);

  const [blacklisttableData, setBlacklisttableData] = useState({ blacklisttableData: [], loading: false } as { blacklisttableData: Array<any>; loading: boolean });
  const [blacklistModal, setBlacklistModal] = useState({ open: false, reason: "" } as { open: boolean; reason?: string });

  useEffect(() => {
    loadTableData();
  }, [reqFilter, props.reload]);

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Requirement_MAST", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + `&tb=${3}`, props.toast);
    if (response) {
      const data: Array<IAllRequirements> = await response.json();
      setTableData({ tableData: data, loading: false });
    } else setTableData({ tableData: tableData.tableData, loading: false });
  };

  const toggleHoldUnhold = async (req_ID: number) => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Requirement_MAST/holdUnhold", "PUT", null, `req_id=${req_ID}`, props.toast);
    if (response) {
      const message = await response.text();
      props.toast.current.show({ severity: "success", detail: message, life: 3000 });
      const data = [...tableData.tableData];
      for (var i in data) {
        if (data[i].req_ID === req_ID) {
          if (data[i].hold) data[i].hold = false;
          else data[i].hold = true;
        }
      }
      setTableData({ tableData: data, loading: false });
    } else setTableData({ tableData: tableData.tableData, loading: false });
  };

  const openNew = () => {
    props.setModal({ open: true, singleData: EmptyRequirement });
  };

  const openEdit = (rowData: IAllRequirements) => {
    props.setModal({ open: true, singleData: { req_ID: rowData.req_ID } });
  };

  const openIncreaseSub = (rowData: IAllRequirements) => {
    props.setModal({ open: true, singleData: { req_ID: rowData.req_ID } });
  };

  const repostRequirement = async (req_ID: number | any) => {
    setAlreadyPostPocLoading(true);
    let query = ``;
    if (alreadyPostPoc == true) {
      query = `req_id=${req_ID}&isCheckExistReq=${1}`;
      props.setSpinner(false);
    } else {
      query = `req_id=${req_ID}`;
    }
    console.log(query);
    const response = await Fetch("Requirement_MAST/repost", "POST", null, query, props.toast);

    if (response) {
      const data: any = await response.json();
      props.setSpinner(false);
      console.log("data", data);
      if (data.type === 1) {
        console.log(1);
        props.toast.current.show({ severity: "error", content: data.message });
        props.setSpinner(false);
        onHideHistoryTable();
        loadTableData();
      } else if (data.type === 2) {
        props.setSpinner(false);

        console.log(2);
        setAlreadyPostPoc(true);
        setExistingPocData({ tableData: data.reqList, loading: false });
      } else {
        setAlreadyPostPoc(false);
        props.setSpinner(false);
        props.toast.current.show({ severity: "success", content: data.message });
        props.setSpinner(false);
        onHideHistoryTable();
        loadTableData();
      }

      // props.setReload(!props.reload);
      if (data.completed == true) {
        props.ShowCelebration();
      }
    } else {
      props.setSpinner(false);
      setExistingPocData({ tableData: existingPocData.tableData, loading: false });
    }
  };

  const repostRequirement1 = async (req_ID: number | any) => {
    // props.setSpinner(true);
    let query = ``;
    if (alreadyPostPoc == true) {
      query = `req_id=${req_ID}&isCheckExistReq=${1}`;
    } else {
      query = `req_id=${req_ID}`;
    }
    console.log(query);
    const response = await Fetch("Requirement_MAST/repost", "POST", null, query, props.toast);

    if (response) {
      const data: any = await response.json();
      props.setSpinner(false);
      console.log("data", data);
      if (data.type === 1) {
        console.log(1);
        props.setSpinner(true);
        props.toast.current.show({ severity: "error", content: data.message });
        props.setSpinner(false);
      } else if (data.type === 2) {
        console.log(2);
        setAlreadyPostPoc(true);
        setExistingPocData({ tableData: data.reqList, loading: false });
      } else {
        setAlreadyPostPoc(false);
        props.setSpinner(true);
        props.toast.current.show({ severity: "success", content: data.message });
        props.setSpinner(false);
      }

      // props.setReload(!props.reload);
      if (data.completed == true) {
        props.ShowCelebration();
      }
    } else {
      props.setSpinner(false);
      setExistingPocData({ tableData: existingPocData.tableData, loading: false });
    }
  };

  const leftToolbarTemplate = () => {
    const st = new Date();
    st.setHours(8, 55, 0, 0);
    const et = new Date();
    et.setHours(18, 0, 0, 0);
    const currentTime = new Date();
    return props.permissions.is_Create ? (
      <React.Fragment>
        <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => props.setReload(!props.reload)} />
        {((loginObj.website_Settings.enable_Add_Req_Time == true && currentTime >= st && currentTime <= et) || loginObj.website_Settings.enable_Add_Req_Time !== true) && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2 my-2" onClick={openNew} />}
        {/* <Button loading={tableData.loading && tab === 1} disabled={tableData.loading && (tab === 2 || tab === 3)} label="All Requirements" className={tab === 1 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTab(1)} /> */}
        {/* <Button loading={tableData.loading && tab === 2} disabled={tableData.loading && (tab === 1 || tab === 3)} label="My Requirements" className={tab === 2 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTab(2)} /> */}
        {/* {loginObj.is_Assign_Major_Tek && <Button loading={tableData.loading && tab === 3} disabled={tableData.loading && (tab === 1 || tab === 2)} label="Major Tech Allocation" className={tab === 3 ? "p-button-info mr-2" : "p-button-secondary mr-2"} onClick={() => setTab(3)} />} */}
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => props.setReload(!props.reload)} />
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return props.permissions.is_Export ? (
      <React.Fragment>
        <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
      </React.Fragment>
    ) : (
      ""
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">My Requirements</h5>
      <span className="block mt-2 md:mt-0 p-input-icon-left">
        <div style={{ display: "flex" }}>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: null };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "DodgerBlue", color: "white" }}
          >
            All
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "UnAllocated" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "skyblue", color: "white" }}
          >
            UnAlloc
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Served" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "green", color: "white" }}
          >
            Served
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Unserved" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "yellow", color: "black" }}
          >
            UnServed
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Rejected" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "red", color: "white" }}
          >
            Rejected
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Updated" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "orange", color: "white" }}
          >
            Updated
          </div>
          {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
        </div>
      </span>
    </div>
  );

  const req_ID = (rowData: IAllRequirements) => {
    return props.permissions.is_Create ? (
      <span onClick={() => setAllocation({ singleData: rowData, open: true })} className="cursor-pointer text-cyan-700 underline">
        {rowData.req_ID}
      </span>
    ) : (
      <span>{rowData.req_ID}</span>
    );
  };
  const req_Job_Title = (rowData: IAllRequirements) => {
    return rowData.rejected_Status === "Yes" ? (
      <span
        onClick={() => {
          setPublish({ singleData: rowData, open: true });
          setRRR({ open: true, rrreason: rowData.rejected_Comment, req_ID: rowData.req_ID });
        }}
        className="cursor-pointer underline"
      >
        <Tag severity="danger" value={rowData.req_Job_Title} />
      </span>
    ) : rowData.req_EditedBy ? (
      <span onClick={() => setPublish({ singleData: rowData, open: true })} className="cursor-pointer underline">
        <Tag severity="warning" value={rowData.req_Job_Title} />
      </span>
    ) : (
      <span onClick={() => setPublish({ singleData: rowData, open: true })} className="cursor-pointer text-cyan-700 underline">
        {rowData.req_Job_Title}
      </span>
    );
  };
  const rejectFunc = () => {
    props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 });
  };

  const confirmDelete = (rowData: any) => {
    confirmDialog({
      message: `Are you sure you want to hold/unhold this requirement`,
      header: "Confirmations",
      icon: "pi pi-exclamation-triangle",
      // defaultFocus: 'reject',
      acceptClassName: "p-button-danger",
      accept: () => toggleHoldUnhold(rowData.req_ID),
      reject: () => rejectFunc(),
    });
  };
  // toggleHoldUnhold(rowData.req_ID)
  const holdUnholdStatus = (rowData: IAllRequirements) => {
    return props.permissions.is_Update ? (
      <span
        onClick={() => {
          if (rowData.req_ID) confirmDelete(rowData);
        }}
        className="cursor-pointer text-cyan-700 underline"
      >
        {rowData.hold ? 'Hold' : "Unhold"}
      </span>
    ) : (
      <>{rowData.hold ? 'Hold' : "Unhold"}</>
    );
  };
  const pDate = (rowData: IAllRequirements) => {
    let date;
    if (rowData.pDate) date = format(new Date(rowData.pDate), "dd/MM/yyyy").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const pTime = (rowData: IAllRequirements) => {
    let date;
    if (rowData?.pDate) date = format(new Date(rowData?.pDate), "hh:mm a").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const submission_id = (rowData: IAllRequirements) => {
    // // console.log('submission_id - ', rowData.submission_id);
    const arOfCons = rowData.submission_id?.split(",");
    const arOfConsId: number[] = [];
    // // console.log('submission_status - ', rowData.submission_status);
    const arOfSubm = rowData.submission_status?.split(",");
    const subm: { [key: string]: number } = {};
    const key: string[] = [];
    // // console.log('recruiter_Name -', rowData.recruiter_Name);
    // const arOfRec = rowData.recruiter_Name?.split(',');
    // const rec: { [key: string]: string } = {};

    arOfCons?.forEach((c) => {
      arOfConsId.push(parseInt(c.split("-")[0]));
      key.push(c.split("-")[0].trim());
    });
    arOfSubm?.forEach((s) => {
      const temp = s.split("-");
      subm[temp[0].trim()] = parseInt(temp[1]);
    });
    // arOfRec?.forEach(r => {
    //     const temp = r.split('-');
    //     rec[temp[0].trim()] = temp[1];
    // });

    let is_Pending = 0;
    if (arOfCons) {
      for (let index = 0; index < arOfCons.length; index++) {
        if (subm[key[index]] === undefined) {
          is_Pending++;
        }
      }
    }
    // // arOfCons?.map((cons, index) => {
    // //     if (index === 0) {
    // //         console.log('arOfCons - ', arOfCons);
    // //         console.log('arOfConsId - ', arOfConsId);
    // //         console.log('arOfSubm - ', arOfSubm);
    // //         console.log('subm - ', subm);
    // //         console.log('key - ', key);
    // //         console.log('arOfRec - ', arOfRec);
    // //         console.log('rec - ', rec);

    // //         console.log('consultant_id - ', arOfConsId[index]);
    // //         console.log('consultant - ', cons);
    // //         console.log('recruiter - ', rec[key[index]]);
    // //         console.log('status - ', subm[key[index]]);
    // //     }
    // // });

    // return (props.permissions.is_Create && myReq ?
    //     <ul>
    //         {arOfCons?.map((cons, index) =>
    //             <li key={index} onClick={() => set({ recruiter: rec[key[index]], req_id: rowData.req_ID, cons_id: arOfConsId[index], vendor_Company_ID: rowData.vendor_Company_ID, status: subm[key[index]], open: true })}
    //                 className='cursor-pointer underline' style={subm[key[index]] !== undefined ? subm[key[index]] === 1 ? { color: "green" } : { color: "#CC0000" } : { color: "var(--cyan-700)" }}>
    //                 {cons}
    //             </li>
    //         )}
    //     </ul> : <span>{rowData.submission_id}</span>);

    const countOfSubmissions = rowData.submission_id?.split(", ").length;
    const color = countOfSubmissions === rowData.noofSUBRej ? "yellow" : countOfSubmissions ? "green" : rowData.recruiter ? "yellow" : "skyblue";

    return props.permissions.is_Create ? (
      <div style={{ background: color, minWidth: "70px", minHeight: "30px", display: "flex", alignItems: "center", justifyContent: "center", padding: "3px" }}>
        <span
          className={countOfSubmissions === rowData.noofSUBRej ? "cursor-pointer underline " : "cursor-pointer text-white underline"}
          onClick={() => {
            if (rowData.req_ID) setSubTable({ req_id: rowData.req_ID, job_Title: rowData.req_Job_Title, open: true });
          }}
        >
          {countOfSubmissions}
          {is_Pending ? ` / ${is_Pending}` : ""}
        </span>
      </div>
    ) : (
      <div style={{ background: color, minWidth: "70px", minHeight: "30px", display: "flex", alignItems: "center", justifyContent: "center", padding: "3px" }}>
        <span className="text-white">{countOfSubmissions}</span>
      </div>
    );
  };

  const getClienttHistoryTable = async (data: IAllRequirements) => {
    setHistoryRepostData({ tableData: historyRepostData.tableData, loading: true });

    const response = await Fetch("Requirement_MAST/getTodayHistory", "GET", null, `contact_Person_Id=${data.pV_Contact_PersonID}`, props.toast);
    if (response) {
      const data: Array<IAllRequirements> = await response.json();
      setHistoryRepostData({ tableData: data, loading: false });
    } else setHistoryRepostData({ tableData: historyRepostData.tableData, loading: false });
  };
  const repostRequirementHistory = (rowData: IAllRequirements | any) => {
    props.setSpinner(true);
    repostRequirement(rowData.req_ID);
  };
  const handleClick = (rowData: IAllRequirements | any) => {
    props.setSpinner(true);
    repostRequirement(rowData.req_ID);
  };
  const FourthAllocationRequest = async (rowData: IAllRequirements | any) => {
    const response = await Fetch("Requirement_MAST/getUnservedListtwo", "GET", null, `req_ID=${rowData.req_ID}`, props.toast);
    if (response) {
      props.toast.current.show({ severity: "success", detail: "4th Allocation Done", life: 3000 });
      loadTableData();
    } else {
      props.toast.current.show({ severity: "error", detail: "Something Went Wrong", life: 3000 });
    }
  };

  const actionBodyTemplate = (rowData: IAllRequirements | any) => {
    let currentDateTime = new Date();
    let isAvailFor4th = new Date(new Date(rowData?.pDate || "").getTime() + 45 * 60000);
    return props.permissions.is_Update ? (
      <>
        <Button
          icon="pi pi-question-circle"
          label="Query"
          className="p-button-rounded p-button-text"
          onClick={() => {
            if (rowData.req_ID) setQuery({ open: true, req_id: rowData.req_ID });
          }}
        />
        <Button icon="pi pi-pencil" label="Edit" className="p-button-rounded p-button-text" onClick={() => openEdit(rowData)} />
        {/* <Button icon="pi pi-send" label="Repost" className="p-button-rounded p-button-info p-button-text" onClick={() => { props.setSpinner(true); if (rowData.req_ID) repostRequirement(rowData.req_ID) }} /> */}
        {rowData.can_Repost == 1 && (
          <Button
            icon="pi pi-send"
            label="Repost"
            className="p-button-rounded p-button-info p-button-text"
            onClick={() => {
              getClienttHistoryTable(rowData);
              setReqTable({ contact_Person_Id: rowData.pV_Contact_PersonID, open: true, loading: true, req_ID: rowData.req_ID });
            }}
          />
        )}
        <Button icon="pi pi-plus" label="Sub" className="p-button-rounded p-button-text" onClick={() => setVisible({ singleData: rowData, open: true })} />
        {currentDateTime >= isAvailFor4th &&
          rowData.rejected_Status === "No" &&
          rowData.company_ID != 4 &&
          rowData.req_Category != 8 &&
          rowData.req_Category != 31 &&
          rowData.reqType_ID != 1 &&
          (!rowData.hold) &&
          (rowData.noSub_Allocated === false || rowData.noSub_Allocated === null) && <Button icon="pi pi-bolt" label="4th" tooltip="4th Allocation" className="p-button-rounded p-button-text" onClick={() => FourthAllocationRequest(rowData)} />}
      </>
    ) : (
      ""
    );
  };

  const onHide = () => {
    props.hideDialog();
    setVisible({ singleData: {}, open: false });
  };
  // const saveToDB = async (requirement:any) => {
  //     console.log(requirement.req_id);
  //     const response = await Fetch("Requirement_MAST/updateMaxSubmission", "POST", null, `req_id=${visible.singleData.req_ID}&max_submission=${visible.singleData.max_Submission}`, props.toast);
  //     if (response) {
  //         props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
  //         loadTableData();
  //     }
  // }

  const HideSubNum = () => {
    props.hideDialog();
    setVisible({ singleData: {}, open: false });
  };

  // const onSubmit = (data: any) => {
  //        saveToDB(data);
  // }

  const onHideHistoryTable = () => {
    setHistoryTable({ req_ID: 0, open: false });
    setReqTable({ contact_Person_Id: 0, open: false, loading: false, req_ID: 0 });
    setAlreadyPostPocLoading(false);
  };

  const loadTableData1 = async (req_ID?: number) => {
    setHistorytableData({ historytableData: historytableData.historytableData, loading: true });
    const response = await Fetch("Requirement_MAST/holdUnholdHistory", "GET", null, `req_id=${req_ID}`, props.toast);
    if (response) {
      const data: Array<any> = await response.json();
      setHistorytableData({ historytableData: data, loading: false });
    } else {
      setHistorytableData({ historytableData: historytableData.historytableData, loading: false });
    }
  };

  const pDate1 = (rowData: any) => {
    let date;
    if (rowData.hold_Unhold_Datee) date = format(new Date(rowData.hold_Unhold_Datee), "dd/MM/yyyy").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const pTime1 = (rowData: any) => {
    let date;
    if (rowData?.hold_Unhold_Datee) date = format(new Date(rowData?.hold_Unhold_Datee), "hh:mm a").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const rowClass = (data: any) => {
    if (data.client_Type === Client_Type.Implementing_Partner) {
      return "bg-pink-100 font-semibold";
    } else if (data.reqType_ID === 1) {
      return "bg-orange-100 font-semibold";
    } else if (data.category) {
      return "bg-indigo-200 font-semibold";
    } else {
      return ""; // default
    }
  };

  const parseRecruiters = (value?: string) => {
    if (!value) return [];

    return value.split(",").map((item) => {
      const [count, ...nameParts] = item.trim().split("-");
      return {
        count: Number(count),
        name: nameParts.join("-").trim(),
      };
    });
  };

  const getEmployeeDetails = async (empCode: string) => {
    const response = await fetch(`${hrLenseBaseUrl}/Tds_Slab/getempbycode?empCode=${empCode}`, { method: "GET" });
    if (response) {
      const data: { employeeId?: number; empCode?: string; phoneNumber?: string; whatsAppNumber?: string; personalEmail?: string } = await response.json();
      setUserModalData({ data });
    }
  };

  const DateFormat = loginObj?.date_Format;
  // useEffect(() => {
  //     loadTableData1(historyTable.req_ID);
  // }, [historyTable])

  const loadBlacklistDetail = async (req_ID?: number) => {
    const response = await Fetch("Requirement_MAST/blacklistSubmission", "GET", null, `req_id=${req_ID}`, props.toast);

    if (response) {
      const data = await response.json();
      setBlacklisttableData({ blacklisttableData: data, loading: false });
    } else {
      setBlacklisttableData({ blacklisttableData: [], loading: false });
    }
  };

  const blacklistDetail = (rowData: IAllRequirements) => {
    const rawValue = rowData.blacklisted_SV_Sub;
    if (!rawValue) return null;

    const blacklistedNames = rawValue.split(",").map((item) => {
      const parts = item.trim().split("-");
      return parts[1]?.trim() || "";
    });

    const handleClick = () => {
      loadBlacklistDetail(rowData.req_ID);
      setOpenBlacklistSubmission(true);
    };

    return (
      <div
        style={{
          color: "#c00",
          cursor: "pointer",
          fontWeight: "500",
          lineHeight: "1.5",
          textDecoration: "underline",
        }}
        onClick={handleClick}
      >
        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          {blacklistedNames.map((name, idx) => (
            <li key={idx}>{name}</li>
          ))}
        </ul>
      </div>
    );
  };

  const blacklistReason = (rowData: any) => {
    return (
      <span
        className="p-link"
        style={{ fontWeight: 600, color: "#14A4E0" }}
        onClick={() => {
          setBlacklistModal({
            open: true,
            reason: rowData.blacklisted_SV_Sub_Reason,
          });
        }}
      >
        View
        {/* <i className="pi pi-eye" style={{ marginLeft: 6 }} /> */}
      </span>
    );
  };

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={3} />
        </AccordionTab>
      </Accordion>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        ref={dt}
        size="small"
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        value={tableData.tableData}
        emptyMessage="No Requirements found."
        header={header}
        loading={tableData.loading}
        rowClassName={rowClass}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
        <Column field="req_ID" header="Req.ID" sortable body={req_ID} />
        <Column field="user_Name" sortable header="Sales Manager" />
        <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
        <Column field="req_Duration" header="Duration" />
        <Column field="location" header="Location" />
        <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
        <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
        <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
        <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
        {/* <Column field="pDate" header="Posted On" body={pDate} /> */}
        <Column field="pDate" style={{ minWidth: "100px" }} header="Posted On" body={(rowData: any) => safeFormatDate(rowData.pDate, "dd/MM/yyyy", DateFormat)} />
        <Column field="pDate" header="Posted Time" body={pTime} />
        <Column field="no_Auto_Allocation" header="Auto Allocation" body={(rowData) => <span style={{ color: rowData.no_Auto_Allocation ? "red" : "green" }}>{rowData.no_Auto_Allocation ? "No" : "yes"}</span>} />
        <Column
          field="recruiter"
          header="Recruiter"
          body={(rowData: any) => {
            const recNames: string[] = (rowData?.recruiter?.trim() || "").split(",").map((elee: string) => elee.trim());
            return rowData?.recruiter !== null && rowData?.recruiter !== undefined ? (
              <div>
                {recNames.map((elN: string) => (
                  <p>
                    <span>{elN.split("-")[0]}</span>-
                    <span
                      className="text-cyan-700 underline cursor-pointer"
                      onClick={() => {
                        if (elN.split("-")[2].toLowerCase().trim() !== "0") {
                          setUserModal({ open: true, data: { name: elN.split("-")[1], email: elN.split("-")[3], empCode: elN.split("-")[2] } });
                          getEmployeeDetails(elN.split("-")[2]);
                        }
                      }}
                    >
                      {elN.split("-")[1]}
                    </span>
                  </p>
                ))}
              </div>
            ) : (
              <></>
            );
          }}
        />
        {/* <Column header="Recruiter" sortable body={(rowData: any) => {
                    const recruiters = parseRecruiters(rowData.recruiter);
                    return (
                        <div className="flex flex-wrap gap-2">
                            {recruiters.map((r, idx) => (
                                <span key={idx} className="text-cyan-700 underline cursor-pointer" onClick={() =>
                                    setUserModal({ open: true, data: { name: r.name, count: r.count } })}
                                >
                                    {r.name}
                                    <span className="text-600 ml-1">({r.count})</span>
                                </span>
                            ))}
                        </div>
                    );
                }}
                /> */}

        <Column field="submission_id" header="Submittals" body={submission_id} />
        <Column field="blacklisted_SV_Sub" header="Blacklisted SV_Submission" body={blacklistDetail} />
        <Column field="req_EndClient" sortable header="End Client" />
        {/* <Column field="client_Type" sortable header="Client Type" /> */}

        <Column field="client" sortable header="My Client" />
        <Column field="contact_Person_Name" header="My Contact Person" />
        <Column field="client_Communication" header="Client Communication" />
        <Column field="special_Constraint" header="Special Constraint" />

        <Column field="hold" header="Status" body={holdUnholdStatus} />
        <Column
          field=""
          header="Hold/Unhold History"
          body={(rowData) => (
            <i
              className="cursor-pointer text-primary pi pi-history"
              onClick={() => {
                loadTableData1(rowData.req_ID);
                setHistoryTable({ req_ID: rowData.req_ID, open: true });
              }}
            ></i>
          )}
        />

        <Column field="max_Submission" header="Max Submission" />

        <Column body={actionBodyTemplate} header="Action" />
      </DataTable>
      <Dialog
        visible={userModal.open}
        onHide={() => {
          setUserModal({ open: false, data: null });
          setUserModalData({ data: null });
        }}
        header="Recruiter Details"
        modal
        style={{ width: "30vw" }}
      >
        {userModalData.data && (
          <div className="p-fluid">
            <div className="border-round surface-card p-4 shadow-2">
              <div className="flex align-items-center mb-4">
                <i className="pi pi-user text-primary text-xl mr-3" />
                <div>
                  <div className="text-900 font-semibold text-lg"> {userModal.data.name} </div>
                  <div className="text-600 text-sm"> Recruiter </div>
                </div>
              </div>
              <div className="grid">
                {userModalData?.data?.personalEmail && (
                  <div className="col-12 flex align-items-center mb-3">
                    <i className="pi pi-envelope text-primary mr-3" />
                    <div>
                      <div className="text-600 text-sm">Professional Email</div>
                      <div className="text-900 font-medium"> {userModal?.data?.email} </div>
                    </div>
                  </div>
                )}
                {userModalData?.data?.personalEmail && (
                  <div className="col-12 flex align-items-center mb-3">
                    <i className="pi pi-envelope text-primary mr-3" />
                    <div>
                      <div className="text-600 text-sm">Email/Hangout</div>
                      <div className="text-900 font-medium"> {userModalData?.data?.personalEmail} </div>
                    </div>
                  </div>
                )}
                {userModalData?.data?.phoneNumber && (
                  <div className="col-12 flex align-items-center mb-3">
                    <i className="pi pi-phone text-primary mr-3" />
                    <div>
                      <div className="text-600 text-sm">Phone</div>
                      <div className="text-900 font-medium"> {userModalData?.data?.phoneNumber} </div>
                    </div>
                  </div>
                )}
                {userModalData?.data?.whatsAppNumber && (
                  <div className="col-12 flex align-items-center mb-3">
                    <i className="pi pi-phone text-primary mr-3" />
                    <div>
                      <div className="text-600 text-sm">WhatsApp</div>
                      <div className="text-900 font-medium"> {userModalData?.data?.whatsAppNumber} </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </Dialog>

      <Allocate roles={_roles} singleData={allocation.singleData} open={allocation.open} hideDialog={hideAllocationDialog} toast={props.toast} />
      <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
      {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={3} /> */}
      <SubmissionsTable req_id={subTable.req_id} job_Title={subTable.job_Title} open={subTable.open} hideDialog={hideSubTable} toast={props.toast} reload={props.reload} setReload={props.setReload} />
      <ReqQuery open={query.open} req_id={query.req_id} hideDialog={hideQueryDialog} toast={props.toast} />
      <Dialog visible={rrr.open} style={{ width: "80vw" }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
        <JVSunEditor value={rrr.rrreason} />
      </Dialog>
      <IncreaseSub singleData={visible.singleData} open={visible.open} loadTableData={loadTableData} toast={props.toast} HideSubNum={HideSubNum} />
      {/* <Dialog header="Increase Sub" visible={visible.open} style={{ width: '300', height: "200" }} onHide={() => setVisible({ singleData: {}, open: false })}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVInput required column={3} label="Total Sub" control={control} name="max_Submission" />
                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <div className="col-12 md:col-12">
                        <Button className="field col-12 md:col-6 h-2rem " label="SAVE" type="submit"></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                    <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}></div>
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                        size="small"
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}
                    >
                        <Column field="max_Submission" header="Max Submission " />
                       
                    </DataTable>
                </form>
            </Dialog> */}
      <Toast ref={toast} />
      <Dialog visible={historyTable.open} style={{ width: "80vw" }} header="Hold/UnHold History" modal className="p-fluid" onHide={onHideHistoryTable}>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} ref={dt} size="small" stripedRows scrollable scrollHeight="65vh" emptyMessage="No Branches found." loading={historytableData.loading} value={historytableData.historytableData}>
          <Column field="updated_By_Name" header="Updated By" />
          {/* <Column field="hold_Unhold_Datee" header="Date" body={pDate1} /> */}
          <Column field="hold_Unhold_Datee" header="Date" body={(rowData: any) => safeFormatDate(rowData.hold_Unhold_Datee, "dd/MM/yyyy", DateFormat)} />
          <Column field="hold_Unhold_Datee" header="Time" body={pTime1} />
          <Column field="holdUnhold_Typee" header="Action" />
        </DataTable>
      </Dialog>
      <ConfirmDialog />
      <Dialog visible={reqTable.open} style={{ width: "80vw" }} header="History of today posted Req on this client" modal className="p-fluid" onHide={onHideHistoryTable}>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} size="small" stripedRows scrollable scrollHeight="65vh" emptyMessage="No requirement found." value={historyRepostData.tableData} loading={historyRepostData.loading}>
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          {/* <Column field="req_ID" header="Req.ID" sortable body={req_ID} /> */}
          <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
          <Column field="req_CategoryName" header="Category" sortable />
          <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
        </DataTable>
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <p className="text-2xl underline" style={{ color: "blue", fontWeight: "bolder" }}>
            Do you want to repost this requirement?
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "5px" }}>
            <Button
              icon="pi pi-check"
              className="p-button-sm my-1 bg-green-500"
              label="Yes"
              loading={alreadyPostPocLoading}
              disabled={alreadyPostPocLoading}
              type="button"
              onClick={() => {
                repostRequirement(reqTable.req_ID);
              }}
            ></Button>
            <Button icon="pi pi-times" className="p-button-sm p-button-danger my-1" label="No" loading={alreadyPostPocLoading} disabled={alreadyPostPocLoading} type="button" onClick={onHideHistoryTable}></Button>
          </div>
        </div>
      </Dialog>
      <Dialog visible={alreadyPostPoc} style={{ width: "80vw" }} header="Requirement with this contact person and category already posted" modal className="p-fluid" onHide={() => setAlreadyPostPoc(false)}>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} size="small" stripedRows scrollable scrollHeight="65vh" emptyMessage="No requirement found." value={existingPocData.tableData} loading={existingPocData.loading}>
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="req_ID" header="Req.ID" sortable />
          <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
          <Column field="req_CategoryName" header="Category" sortable />
          <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
        </DataTable>
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <p className="text-2xl underline" style={{ color: "Red", fontWeight: "bolder" }}>
            Do you really want to post this Requirement?
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "5px" }}>
            <Button
              icon="pi pi-check"
              className="p-button-sm my-1 bg-green-500"
              label="Continue"
              type="button"
              onClick={() => {
                repostRequirement(reqTable.req_ID);
                props.setSpinner(true);
              }}
            ></Button>
            <Button
              icon="pi pi-times"
              className="p-button-sm p-button-danger my-1"
              label="Cancel"
              type="button"
              onClick={() => {
                setAlreadyPostPoc(false);
              }}
            ></Button>
          </div>
        </div>
      </Dialog>
      {/* ------------------Blacklist Submission Modal -------------------- */}
      <Dialog visible={openBlacklistSubmission} header="Blacklisted Submissions" onHide={() => setOpenBlacklistSubmission(false)} modal style={{ width: "60vw" }}>
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          ref={dt}
          size="small"
          stripedRows
          scrollable
          scrollHeight="65vh"
          emptyMessage="No Blacklisted SV_Submission found."
          loading={blacklisttableData.loading}
          value={blacklisttableData.blacklisttableData}
        >
          <Column field="vendor_Company_Name" header="SubVendor Company" />
          <Column field="consultantName" header="Consultant" />
          <Column field="recruiter_Name" header="Recruiter" />
          <Column field="submitalDate" header="Submission Date" body={(rowData: any) => safeFormatDate(rowData.submitalDate, "dd/MM/yyyy", DateFormat)} />
          <Column header="Submission Reason" body={blacklistReason} />
        </DataTable>
      </Dialog>
      {/*--------------------------------- Blacklist Submission Reason----------------------------------------- */}
      <Dialog visible={blacklistModal.open} onHide={() => setBlacklistModal({ open: false, reason: "" })} modal header="Submission Reason" style={{ width: "30vw" }}>
        <p>{blacklistModal.reason}</p>
      </Dialog>
    </>
  );
};
